'use client';

import React from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/solid';

export default function SearchBox() {
  const [searchTerm, setSearchTerm] = React.useState('');

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const query = params.get('q');
    if (query) {
      setSearchTerm(query);
    }
  }, []);

  const handleSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!searchTerm) return;
    
    const params = new URLSearchParams(window.location.search);
    params.set('q', searchTerm);
    window.history.pushState(null, '', `?${params.toString()}`);
    window.dispatchEvent(new CustomEvent('search', { detail: searchTerm }));
  };

  return (
    <form onSubmit={handleSearch} className="mb-8 pb-8 max-w-2xl mx-auto">
      <div className="relative">
        <input
          type="search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="検索キーワードを入力"
          className="w-full p-4 border rounded-lg shadow-sm focus:ring-2 focus:primary focus:primary-dark bg-header-bg"
          aria-label="検索"
        />
        <button
          type="submit"
          className="absolute right-3 top-1/2 -translate-y-1/2 px-4 py-2 bg-background text-white rounded-md hover:bg-hover focus:outline-none focus:ring-2 focus:ring-offset-2 flex items-center"
        >
          <MagnifyingGlassIcon className="w-5 h-5 mr-2" />
          検索
        </button>
      </div>
    </form>
  );
}
